import React, {useEffect, useState} from "react";
import ErrorBoundary from "./ErrorBoundary";
import {Button} from "react-bootstrap";
import { use } from "react";

const DisplaySingleChildComponent = ({child, index, deleteChild, updateChild, localAuthorities, schools, schoolYears, concernLevels, genders}) => {
    const [isEdit, setIsEdit] = useState(false)
    const buttons = (formChildData, resetFormChildData) => {

        function handleCancel() {
            resetFormChildData()
            setIsEdit(false)
        }

        function isChildValid() {
           return !formChildData.errors?.has_creation_error
        }

        function handleUpdate() {
            if(isChildValid()) {
                formChildData.edited = true
                updateChild(formChildData, index)
                setIsEdit(!isEdit)
            }
        }

        return <>
            <Button onClick={handleUpdate} type="button" bsStyle="info"
                    className={'display-inline-block mr-3'} disabled={!isChildValid()}>
                Update
            </Button>
            <Button onClick={handleCancel} type="button" className={'display-inline-block btn-warning mr-3'} id={'cancelEditChildFormData'}>
                Cancel
            </Button>
            <Button onClick={() => deleteChild(index)} type={"button"} bsStyle="danger"
                    className={'display-inline-block'} id={'deleteChildFormData'}>
                Delete
            </Button>
        </>
    }

    if (child.mark_for_deletion) {
        return <div hidden>marked for deletion: {child.id}</div>
    }

    function getSchool(schoolId) {
        return schools?.find((school) => String(school.id) === String(schoolId))
    }

    function getLocalAuthority(localAuthorityId) {
        return localAuthorities?.find((localAuthority) => String(localAuthority.id) === String(localAuthorityId))
    }


    if (isEdit) {
        return <tr>
            <td colSpan={8}>
                <ChildFormComponent childData={child} buttons={buttons} localAuthorities={localAuthorities} schools={schools} concernLevels={concernLevels} schoolYears={schoolYears} genders={genders} />
            </td>
        </tr>
    } else {

        return <>
            {child?.error_messages?.length > 0 && !child?.edited &&
                <tr>
                    <span className={'text-danger'}>{child?.error_messages}</span>
                </tr>
            }
            <tr className={`${child?.error_messages?.length > 0 && !child?.edited ? 'danger' : ''}`}>
                <td className="col-sm-2 child_local_authority">{getLocalAuthority(child.local_authority_id)?.description}</td>
                <td className="col-sm-2 child_school">{getSchool(child.school_id)?.description}</td>
                <td className="col-sm-2 child_school_year">{child.school_year}</td>
                <td className="col-sm-3 child_name">{child.first_name} {child.last_name}</td>

                <td scope="col-sm-2" className={'child_buttons'}>
                    <Button onClick={() => setIsEdit((!isEdit))} type="button" bsStyle="info"
                            className={'display-inline-block mr-3'}>
                        Edit
                    </Button>
                    <Button onClick={() => deleteChild(index)} type="button" bsStyle="danger"
                            className={'display-inline-block'}>
                        Delete
                    </Button>
                </td>
            </tr>
        </>
    }
}

const CreateChildComponent = ({addChild, maximumNumbers, currentNumberCount, localAuthorities, schools, schoolYears, concernLevels, genders}) => {
    const [isCreating, setIsCreating] = useState(false);

    const formButtons = (formChildData, resetChildData) => {

        function createChild() {
            if (!formChildData.errors.has_creation_error) {
                addChild(formChildData)
                resetChildData()
                setIsCreating(!isCreating)
            }
        }

        return <>
            <Button onClick={createChild} type="button" id={'addChildForm'}
                    className={'display-inline-block mr-3 btn-success'}
                    disabled={formChildData.errors.has_creation_error}>
                Add
            </Button>
            <Button onClick={resetChildData} type="button" id={'resetChildForm'}
                    className={'display-inline-block mr-3 btn-warning'}>
                Reset
            </Button>
            <Button onClick={() => setIsCreating(!isCreating)} type="button" id={'cancelChildForm'}
                    className={'display-inline-block mr-3 btn-danger'}>
                Cancel
            </Button>
        </>

    }

    function creationForm() {
        if (isCreating) {
            return <ChildFormComponent buttons={formButtons} localAuthorities={localAuthorities} schools={schools} concernLevels={concernLevels} schoolYears={schoolYears} genders={genders} />
        } else {
            if(currentNumberCount >= maximumNumbers) {
                return <span className={'text-warning'} id={'maximumNumberMessage'}>Client reached the maximum {maximumNumbers} stored children.</span>
            } else {
                return <Button onClick={() => setIsCreating(!isCreating)} type="button"
                               className={'display-inline-block mr-3 btn-success'}>
                    Add a new child
                </Button>
            }
        }
    }

    return <div>        
        <div id={'createChild'}>
            {creationForm()}
        </div>
        <hr/>
    </div>
}

const ChildFormComponent = ({buttons, childData, localAuthorities, schools, schoolYears, concernLevels, genders}) => {    
    const defaultErrors = {
        has_creation_error: true,
        local_authority_id: "",
        school_id: "",
        school_year: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        gender: "",
        looked_after_by_authority: false,
        care_experienced: false,
        level_of_concern: ""
    }

    const formChildDefaults = childData || {
        local_authority_id: "",
        school_id: "",
        school_year: "",
        first_name: "",
        last_name: "",
        date_of_birth: "",
        gender: "",
        looked_after_by_authority: false,
        care_experienced: false,
        level_of_concern: ""
    }
    if (!formChildDefaults.errors) {
        formChildDefaults.errors = JSON.parse(JSON.stringify(defaultErrors))
    }
    const [formChildData, setFormChildData] = useState(JSON.parse(JSON.stringify(formChildDefaults)))
    const [filteredSchools, setFilteredSchools] = useState([])

    function resetFormChildData() {
        setFormChildData(JSON.parse(JSON.stringify(formChildDefaults)))
    }

    function setField(field, value) {
        let processingData = resetErrors(formChildData)
        processingData[field] = value
        setFormChildData({...formChildData, ...validateChild(processingData)})
    }

    function resetErrors(childData) {
        if(childData.errors.length > 0) {
            return {
                ...childData,
                errors: JSON.parse(JSON.stringify(defaultErrors))
            }
        }
        return childData
    }

    function validateChild(childFormData) {
        let errors = JSON.parse(JSON.stringify(defaultErrors))
        let hasCreationError = false
        if (!childFormData?.local_authority_id && childFormData?.local_authority_id?.length === 0) {
            errors.local_authority_id = "You must select a local authority"
            hasCreationError = true
        }
        if (!childFormData?.school_id && childFormData?.school_id?.length === 0) {
            errors.school_id = "You must select a school"
            hasCreationError = true
        }
        if (!childFormData?.school_year && childFormData?.school_year?.length === 0) {
            errors.school_year = "You must select a school year"
            hasCreationError = true
        }
        if (!childFormData?.first_name && childFormData?.first_name?.length === 0) {
            errors.first_name = "You must enter a first name"
            hasCreationError = true
        }
        if (!childFormData?.last_name && childFormData?.last_name?.length === 0) {
            errors.last_name = "You must enter a last name"
            hasCreationError = true
        }
        if (!childFormData?.date_of_birth && childFormData?.date_of_birth?.length === 0) {
            errors.date_of_birth = "You must enter a date of birth"
            hasCreationError = true
        }
        if (!childFormData.gender && childFormData.gender.length === 0) {
            errors.gender = "You must select a gender"
            hasCreationError = true
        }
        if (!childFormData.level_of_concern && childFormData.level_of_concern.length === 0) {
            errors.level_of_concern = "You must select a level of concern at referral"
            hasCreationError = true
        }

        childFormData.errors = errors
        childFormData.errors.has_creation_error = hasCreationError
        return childFormData
    }

    useEffect(() => {
        // when the local authority changes, filter the schools
        const filteredSchools = schools?.filter((school) => String(school.parent_id) === String(formChildData.local_authority_id))
        setFilteredSchools(filteredSchools)
    }, [formChildData?.local_authority_id])

    return <div className={'form-group'} id={'child-form'}>
        <div className={'row'}>
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.local_authority_id?.length ? 'has-error' : ''}`}>
                    <label htmlFor="local-authority">Local Authority</label>
                    <select className="form-control" id={'local-authority'} value={formChildData?.local_authority_id}
                            placeholder={'Select a Local Authority'}
                            onChange={event => {
                                setField('local_authority_id', event.target.value)                                
                            }}>
                        <option value={""}>Select a local authority</option>
                        {localAuthorities?.map((localAuthority, index) => {
                            return <option key={`local-authority-${index}`} value={localAuthority.id}>{localAuthority.description}</option>
                        })}
                    </select>
                    <span className="text-danger" id={'local-authority-error'}>{formChildData?.errors?.local_authority_id}</span>
                </div>
            </div>
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.school_id?.length ? 'has-error' : ''}`}>
                    <label htmlFor="school">School</label>
                    <select className="form-control" id={'school'} value={formChildData?.school_id}
                            placeholder={'Select a school'}
                            onChange={event => {
                                setField('school_id', event.target.value)
                            }}>
                        <option value={""}>Select a school</option>
                        {filteredSchools?.map((school, index) => {
                            return <option key={`school-${index}`} value={school.id}>{school.description}</option>
                        })}
                    </select>
                    <span className="text-danger" id={'school-error'}>{formChildData?.errors?.school_id}</span>
                </div>
            </div>
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.school_year?.length ? 'has-error' : ''}`}>
                    <label htmlFor="school-year">School Year</label>
                    <select className="form-control" id={'school-year'} value={formChildData?.school_year}
                            onChange={event => setField('school_year', event.target.value)}>
                        <option value={""}>Select a school year</option>
                        {schoolYears?.map((year, index) => {
                            return <option key={`school-year-${index}`} value={year.description}>{year.description}</option>
                        })}
                    </select>
                    <span className="text-danger" id={'school-year-error'}>{formChildData?.errors?.school_year}</span>
                </div>
            </div>
        </div>
        <div className="row top-space">
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.gender?.length ? 'has-error' : ''}`}>
                    <label htmlFor="gender">Gender</label>
                    <select className="form-control" id={'gender'} value={formChildData?.gender}
                            onChange={event => setField('gender', event.target.value)}>
                        <option value={""}>Select a gender</option>
                        {genders?.map((gender, index) => {
                            return <option key={`gender-${index}`} value={gender.description}>{gender.description}</option>
                        })}
                    </select>
                    <span className="text-danger" id={'gender-error'}>{formChildData?.errors?.gender}</span>
                </div>
            </div>
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.level_of_concern?.length ? 'has-error' : ''}`}>
                    <label htmlFor="loc">Level of Concern</label>
                    <select className="form-control" id={'loc'}
                            value={formChildData?.level_of_concern}
                            onChange={event => setField('level_of_concern', event.target.value)}>
                        <option value={""}>Select level of concern at referral</option>
                        {concernLevels?.map((level, index) => {
                            return <option key={`concern-level-${index}`} value={level.description}>{level.description}</option>
                        })}
                    </select>
                    <span className="text-danger"
                          id={'loc-error'}>{formChildData?.errors?.level_of_concern}</span>
                </div>
            </div>
        </div>
        <div className={'row top-space'}>
            <div className="col-sm-4">
            <div className={`${formChildData?.errors?.first_name?.length ? 'has-error' : ''}`}>
                    <label htmlFor="first-name">First Name</label>
                    <input className="form-control" type="text" id={'first-name'}
                           placeholder={'First Names'}
                           value={formChildData?.first_name}
                           onChange={event => setField('first_name', event.target.value)}
                    />
                    <span className="text-danger" id={'first-name-error'}>{formChildData?.errors?.first_name}</span>
                </div>
            </div>
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.last_name?.length ? 'has-error' : ''}`}>
                    <label htmlFor="last-name">Last Name</label>
                    <input className="form-control" type="text" id={'last-name'}
                           placeholder={'Last Name'}
                           value={formChildData?.last_name}
                           onChange={event => setField('last_name', event.target.value)}
                    />
                    <span className="text-danger" id={'last-name-error'}>{formChildData?.errors?.last_name}</span>
                </div>
            </div>
            <div className="col-sm-4">
                <div className={`${formChildData?.errors?.date_of_birth?.length ? 'has-error' : ''}`}>
                    <label htmlFor="dob">Date of Birth</label>
                    <input className="form-control" id={'dob'}
                           type={'date'}
                           value={formChildData?.date_of_birth}
                           onChange={event => setField('date_of_birth', event.target.value)}
                    />
                    <span className="text-danger" id={'dob-error'}>{formChildData?.errors?.date_of_birth}</span>
                </div>
            </div>
        </div>
        <div className={'row top-space'}>
            <div className={'col-sm-12'}>
                <div class="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" id="looked_after_by_authority"
                       checked={formChildData?.looked_after_by_authority}
                       onChange={event => setField('looked_after_by_authority', event.target.checked)}
                    />
                    <label htmlFor="looked_after_by_authority" className={'form-check-label'}>Looked after by authority?</label>
                </div>                
                <div class="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" id="care_experienced"
                        checked={formChildData?.care_experienced}
                        onChange={event => setField('care_experienced', event.target.checked)}
                    />
                    <label htmlFor="care_experienced" className={'form-check-label'}>Care experienced?</label>
                </div>
                <div class="form-check form-check-inline">
                    <input className="form-check-input" type="checkbox" id="child_accessed_exchange_before"
                        checked={formChildData?.child_accessed_exchange_before}
                        onChange={event => setField('child_accessed_exchange_before', event.target.checked)}
                    />
                    <label htmlFor="child_accessed_exchange_before" className={'form-check-label'}>Accessed Exchange support before?</label>
                </div>
            </div>
        </div>

        <div className={'row top-space'}>
            <div className={'col-sm-12'}>
            <div className={'pull-right'}>
                    {buttons(formChildData, resetFormChildData, validateChild)}
                </div>
            </div>
        </div>
    </div>
}
const ChildListComponent = ({onChange, localAuthorities, schools, schoolYears, concernLevels, genders, maximumChildren, objectName}) => {
    const [childList, setChildList] = useState([])

    useEffect(() => {
        if (onChange) {
            onChange(childList)
        }
    }, [childList])

    function addChild(child) {
        setChildList([...childList, child])
    }

    function updateChild(formChildData, index) {
        childList[index] = formChildData
        setChildList([...childList])
    }

    function deleteChild(index) {
        if (window.confirm('Are you sure you wish to delete this child?')) {
            const toDelete = childList[index]
            if(toDelete.id) {
                toDelete.mark_for_deletion = true
            } else {
                childList.splice(index, 1)
            }
            setChildList([...childList])
        }
    }

    // pass JS values to ruby controller in a 'hackyish' way
    // reason for not mapping out input completely:
    // 1. update will not support removing items
    // 2. this becomes extremely nested and hard to maintain and parse
    function listDataAsRubyForm() {
        return <input readOnly type={'textbox'} name={`${objectName}[client_children_json]`} value={JSON.stringify(childList)} hidden/>
    }

    function listChildren() {
        return (!!childList?.length) && (
            <table className="table table-bordered table-sm">
                <thead>
                    <tr>
                        <th className="col-sm-2">Local Authority</th>
                        <th className="col-sm-2">School</th>
                        <th className="col-sm-2">School Year</th>
                        <th className="col-sm-3">Name</th>
                        <th className="col-sm-2">Actions</th>

                    </tr>
                </thead>
                <tbody id={'childRows'}>
                    {childList?.filter((child) => !child.mark_for_deletion)?.length > 0 ? childList.map((child, index) =>
                            <DisplaySingleChildComponent child={child} index={index} key={`child-${index}`}
                                                        deleteChild={deleteChild} updateChild={updateChild}
                                                        localAuthorities={localAuthorities}
                                                        schools={schools}
                                                        concernLevels={concernLevels}
                                                        schoolYears={schoolYears}
                                                        genders={genders}
                            />) :
                        <tr>
                            <td colSpan={8}>There are no children to display.</td>
                        </tr>
                    }
                </tbody>
            </table>
        )
    }

    return <>
        {listChildren()}
        <CreateChildComponent
            addChild={addChild}
            currentNumberCount={childList?.length || 0}
            maximumNumbers={maximumChildren || 3}
            localAuthorities={localAuthorities}
            schools={schools}
            concernLevels={concernLevels}
            schoolYears={schoolYears}
            genders={genders}
        />
        {listDataAsRubyForm()}
    </>
}

const ChildrenForm = (props) => {
    return (
        <ErrorBoundary>
            <ChildListComponent {...props} />
        </ErrorBoundary>
    )
}

export default ChildrenForm;